import React from 'react';
import i18n from '../../../../i18n';

const DatePickerCustomHeader = ({ date, monthDate, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
    // When `monthsShown > 1`, React DatePicker provides `monthDate` for the specific panel.
    // Using `date` can render the same month in both headers.
    const headerDate = monthDate || date;
    return (
        <div className="react-datepicker-custom-header">
            <div className="d-flex justify-content-between align-items-center p-3">
                <button
                    type="button"
                    onClick={decreaseMonth}
                    disabled={prevMonthButtonDisabled}
                    className="btn btn-sm btn-link text-white"
                    style={{ padding: '0.25rem 0.5rem' }}
                >
                    ‹
                </button>
                <div className="d-flex gap-2 align-items-center">
                    <select
                        value={headerDate.getMonth()}
                        onChange={({ target: { value } }) => changeMonth(parseInt(value))}
                        className="form-select form-select-sm"
                        style={{ width: 'auto', minWidth: '120px' }}
                    >
                        {Array.from({ length: 12 }, (_, i) => {
                            const monthName = new Date(2000, i, 1).toLocaleDateString(i18n.language || 'nl-NL', { month: 'long' });
                            return (
                                <option key={i} value={i}>
                                    {monthName.charAt(0).toUpperCase() + monthName.slice(1)}
                                </option>
                            );
                        })}
                    </select>
                    <select
                        value={headerDate.getFullYear()}
                        onChange={({ target: { value } }) => changeYear(parseInt(value))}
                        className="form-select form-select-sm"
                        style={{ width: 'auto', minWidth: '80px' }}
                    >
                        {Array.from({ length: 20 }, (_, i) => {
                            const year = new Date().getFullYear() - 5 + i;
                            return (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            );
                        })}
                    </select>
                </div>
                <button
                    type="button"
                    onClick={increaseMonth}
                    disabled={nextMonthButtonDisabled}
                    className="btn btn-sm btn-link text-white"
                    style={{ padding: '0.25rem 0.5rem' }}
                >
                    ›
                </button>
            </div>
        </div>
    );
};

export default DatePickerCustomHeader;
























